import { proxy } from 'valtio'

const state = proxy({
  colors: [
    '#0A0A0A', // Nero Noctis (Gloss Black)
    '#FFD700', // Giallo Orion (Gold Yellow)
    '#ffffff', // Bianco Isis (Pure White)
    '#85C1E9', // Blu Caelum (Light Sky Blue)
  ],
  selectedColor: '#0A0A0A',
  // SSR safe - typeof window check
  isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false
})

export { state }
